import {Injectable} from '@angular/core';
import {EntityState, EntityStore, StoreConfig} from '@datorama/akita';
import {ProductParameter} from './model';

export interface ProductParameterState extends EntityState<ProductParameter> {}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'ProductParameter' })
export class Store extends EntityStore<ProductParameterState> {

  constructor() {
    super();
  }

}
